import { render } from "./InputImage.vue?vue&type=template&id=efb2b568&scoped=true"
import script from "./InputImage.vue?vue&type=script&lang=js"
export * from "./InputImage.vue?vue&type=script&lang=js"

import "./InputImage.vue?vue&type=style&index=0&id=efb2b568&scoped=true&lang=scss"

import exportComponent from "/Users/adrianfraczak/Projects/Actual/GC/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efb2b568"]])

export default __exports__